import React from 'react';
import './ButtonLoader.css';

const ButtonLoader = () => {
    return (
        <React.Fragment>
            <div className="spinner"></div>
        </React.Fragment>
    );
};

export default ButtonLoader;